import request from "@/utils/request.js";
import {
  clos_encryptDes,
  clos_encryptDes1,
  clos_encryptDes2,
  clos_encryptDesForApp,
  time as initTime,
} from "@/encryption";

let accessKeyId = "APId1482c4fc9";
let deviceId = "123";

let url =
  process.env.NODE_ENV === "production"
      // ? "/api/dispatcher"
      // : "/api/dispatcher";
    ? "information/api/dispatcher"
    : "information/api/dispatcher";

export const getAdvertise = (args) => {
  let { action, id, time } = args,
    timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    id,
    deviceId,
  };
  return request({
    url: url,
    method: "post",
    data,
  });
};

export const getCountDownload = (args) => {
  let { action, timestamp,time } = args
  let signature = clos_encryptDes1(action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    time
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/backEnd/api/dispatcher',
    method: "post",
    data,
  });
};

// 获取咨询详情
export const getInformation = (args) => {
  let { action, time, articleId, userId } = args,
    timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    articleId,
    userId,
  };
  return request({
    url,
    method: "POST",
    data,
  });
};

// getInforWatch
export const getInforWatch = (args) => {
  let { action, time, id} = args,
      timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    id
  };
  return request({
    url,
    method: "POST",
    data,
  });
};

export const getRecommend = (args) => {
  let { action, time, cityId } = args,
    timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    cityId,
  };
  return request({
    url,
    method: "POST",
    data,
  });
};

export const getRecommendRead = (args) => {
  let { action, time, id } = args,
    timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    id,
  };
  return request({
    url,
    method: "POST",
    data,
  });
};

export const getShareInfo = (args) => {
  let { action, time } = args,
    timestamp = time;
  let signature = clos_encryptDes(deviceId, action, time);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId
  };
  return request({
    url:'https://www.fangpinyouxuan.com/information/api/dispatcher',
    method: "POST",
    data,
  });
};

export const getVersion = (args) => {
  const { action, time, type } = args,
    timestamp = time;
  const signature = clos_encryptDes(deviceId, action, time);
  const data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    type,
  };
  return request({
    url: "huiyuan/api/dispatcher",
    method: "POST",
    data,
  });
};

export const uploadimg = (args) => {
  let { file,action, timestamp } = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    file,
    deviceId
  };
  return request({
    url: 'http://192.168.8.37:8081/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
export const getCheckCode = (args) => {
  let {action, timestamp,name,phone,wechatNumber, age, marriage, job, region, socialSecurity, census, annualIncome, housePurchase, intentionRegion,
    purchaseTyp,
    manageIntroduce,
    creditReport,
    businessLicense,
    premises } = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    name,//姓名
    phone,//电话
    wechatNumber,
    age,//年龄
    marriage,//婚姻
    job,//职业
    region,//区域
    socialSecurity,//社保
    census,//户籍
    annualIncome,//年收入
    housePurchase,//购房需求
    intentionRegion,//意向区域
    purchaseTyp,//购房类型
    manageIntroduce,//经营简介
    creditReport,//经营报告
    businessLicense,//营业执照
    premises,//经营场所

  };
  return request({
    url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
//获取短信验证码
export const emailcode = (args) => {
  let {action, timestamp,phoneNumber} = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    phoneNumber ,//电话
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    // url: 'http://192.168.8.37:8081/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
//获取短信验证码后提交的接口
export const Submit = (args) => {
  let {action, timestamp,phoneNumber,verifyCode} = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    phoneNumber ,//电话
    verifyCode,//验证码
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    // url: 'http://192.168.8.37:8081/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
//获取短信验证码后提交的接口
export const properties = (args) => {
  let {action, timestamp,name} = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
    name ,//楼盘名称
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    // url: 'http://192.168.8.37:8081/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
//获取图片的接口
export const getimgnow = (args) => {
  let {action, timestamp} = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    // url: 'http://192.168.8.37:8081/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    data,
  });
};
//获取落地页信息的接口
export const getLandingpage = (args) => {
  let {action, timestamp} = args
  console.log(deviceId)
  let signature = clos_encryptDes(deviceId,action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    deviceId,
  };
  return request({
    url: 'https://www.fangpinyouxuan.com/information/api/dispatcher',
    // url: 'http://192.168.8.74:8083/api/dispatcher',
    method: "post",
    data,
  });
};



export const getcodema = (args) => {
  let {action, timestamp,phone,memberLevel

  } = args
  console.log(deviceId)
  // let signature = clos_encryptDes(deviceId,action, timestamp);
  let signature = clos_encryptDes1(action, timestamp);
  let data = {
    action,
    accessKeyId,
    signature,
    timestamp,
    // deviceId,
    phone,
    memberLevel


  };
  return request({
    // url: 'https://www.fangpinyouxuan.com/huiyuan/api/dispatcher',
    url: 'http://192.168.8.37:8082/api/dispatcher',
    // http://192.168.8.12:8081/api/dispatcher
    method: "post",
    // responseType:"blob",
    data,
  });
};
// export function uploadImg(data){
//   let formData = new FormData()
//   formData.append('file',data.file)
//   return ajax('/img/uploadImg', formData,{
//     headers:{'Content-Type':'multipart/form-data'}
//   })
// }
